import {dehydrate, QueryClient} from '@tanstack/react-query';

import {disallowSlug, RENDER_MODES} from '@udemy/nextjs-core';

import {FeaturedTopicsPage} from 'src/features/featured-topics';
import {getCompactTranslations} from 'src/lib-server/locale.server';
import {FOUR_HOURS} from 'src/lib/constants';
import {AppContextData} from 'src/types/page-props';

import {getStaticAppContext} from '../api/context.api';

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}

export const getStaticProps = disallowSlug(async ({locale}) => {
    locale = locale as string;
    const translations = await getCompactTranslations(locale);
    const client = new QueryClient();

    // Resolve appContext
    const [staticData] = await Promise.all([getStaticAppContext({locale})]);
    const appContext: AppContextData = {
        ...staticData,
        // application specific context can go here
    };

    return {
        props: {
            appContext,
            dehydratedState: dehydrate(client),
            locale,
            pageKey: 'discovery_featured_topics',
            renderMode: RENDER_MODES.ISR, // supports render functions in _document.tsx and _app.tsx.
            translations,
        },
        revalidate: FOUR_HOURS,
    };
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function FeaturedTopics(props: any) {
    return <FeaturedTopicsPage {...props} />;
}

FeaturedTopics.getLayout = FeaturedTopicsPage.getLayout;
